import { PrincipalDataFragment } from '../types-graphql';

export type ApiPrincipal = PrincipalDataFragment;

export type PrincipalEmail = string;
export type PrincipalUserId = string; // UUID
export type ServiceAccountId = string; // UUID
export type PrincipalIdentifier = string;

export enum PrincipalTypes {
  USER = 'user',
  SERVICE_ACCOUNT = 'serviceAccount',
}

export interface UserPrincipal {
  type: PrincipalTypes.USER;
  email: PrincipalEmail;
  id: PrincipalUserId;
}

export interface ServiceAccountPrincipal {
  type: PrincipalTypes.SERVICE_ACCOUNT;
  serviceAccountId: ServiceAccountId;
}

// The caller identity behind a persisted record - a human user or a service account
export type Principal = UserPrincipal | ServiceAccountPrincipal;
